webpackJsonp([244936145555461],{

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stateLabel = function stateLabel(states) {
	  if (states.indexOf('B') > -1) return 'B - sending command';
	  if (states.indexOf('W') > -1) return 'W - waiting for reply';
	  if (states.indexOf('P') > -1) return 'P - supplying password';
	  if (states.indexOf('S') > -1) return 'S - success';
	  if (states.indexOf('F') > -1) return 'F - failure';
	  return 'I - initial';
	};
	
	var FtpClientPanel = function FtpClientPanel(_ref) {
	  var configuration = _ref.configuration,
	      datamodel = _ref.datamodel,
	      commands = _ref.commands,
	      log = _ref.log,
	      onEvent = _ref.onEvent;
	
	  var states = configuration || [];
	  var currentCommand = datamodel && datamodel.currentCommand ? datamodel.currentCommand : '';
	  var lastReply = datamodel && datamodel.lastReply ? datamodel.lastReply : 'none';
	  var commandIndex = datamodel && typeof datamodel.commandIndex !== 'undefined' ? datamodel.commandIndex : 0;
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', padding: '1rem', background: '#f7f7f7', overflow: 'auto' } },
	    _react2.default.createElement(
	      'div',
	      { style: { background: '#fff', border: '1px solid #ddd', padding: '1rem', marginBottom: '1rem' } },
	      _react2.default.createElement(
	        'div',
	        { style: { color: '#666', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.08em' } },
	        'FTP state'
	      ),
	      _react2.default.createElement(
	        'h3',
	        { style: { margin: '0.25rem 0' } },
	        stateLabel(states)
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        'Current command: ',
	        currentCommand || 'none'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        'Last reply: ',
	        lastReply
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        'Command index: ',
	        commandIndex
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginBottom: '1rem' } },
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-primary', style: { marginRight: '0.5rem', marginBottom: '0.5rem' }, onClick: function onClick() {
	            return onEvent('control.opened');
	          } },
	        'Open control channel'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-success', style: { marginRight: '0.5rem', marginBottom: '0.5rem' }, onClick: function onClick() {
	            return onEvent({ name: 'reply.2xx', data: '200 OK' });
	          } },
	        '2xx reply'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-secondary', style: { marginRight: '0.5rem', marginBottom: '0.5rem' }, onClick: function onClick() {
	            return onEvent({ name: 'reply.3xx', data: '331 Password required' });
	          } },
	        '3xx password'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-danger', style: { marginBottom: '0.5rem' }, onClick: function onClick() {
	            return onEvent({ name: 'reply.5xx', data: '550 File unavailable' });
	          } },
	        '5xx failure'
	      )
	    ),
	    _react2.default.createElement(
	      'strong',
	      null,
	      'Commands sent'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { margin: '0.5rem 0 1rem', fontFamily: 'monospace', fontSize: '0.85rem' } },
	      (commands || []).map(function (command, index) {
	        return _react2.default.createElement(
	          'div',
	          { key: command + '-' + index },
	          command
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'strong',
	      null,
	      'Trace'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginTop: '0.5rem', fontFamily: 'monospace', fontSize: '0.85rem' } },
	      (log || []).map(function (entry, index) {
	        return _react2.default.createElement(
	          'div',
	          { key: entry + '-' + index, style: { padding: '0.3rem 0', borderTop: index ? '1px solid #e2e2e2' : 0 } },
	          entry
	        );
	      })
	    )
	  );
	};
	
	exports.default = FtpClientPanel;
	module.exports = exports['default'];

/***/ }),

/***/ 894:
/***/ (function(module, exports) {

	module.exports = "<scxml datamodel=\"ecmascript\"\n       initial=\"I\"\n       name=\"SimpleFtpClient\"\n       version=\"1.0\"\n       xmlns=\"http://www.w3.org/2005/07/scxml\">\n  <datamodel>\n    <data id=\"commands\" expr=\"['USER anonymous', 'PORT 127,0,0,1,12,34', 'RETR readme.txt']\"/>\n    <data id=\"commandIndex\" expr=\"0\"/>\n    <data id=\"currentCommand\" expr=\"''\"/>\n    <data id=\"lastReply\" expr=\"''\"/>\n  </datamodel>\n\n  <state id=\"I\">\n    <onentry>\n      <send event=\"trace\"><content expr=\"'Initial state: connect to the FTP control channel.'\"/></send>\n    </onentry>\n    <transition event=\"control.opened\" target=\"B\"/>\n  </state>\n\n  <state id=\"B\" initial=\"B_check\">\n    <state id=\"B_check\">\n      <transition cond=\"commandIndex &gt;= commands.length\" target=\"S\"/>\n      <transition target=\"B_send\"/>\n    </state>\n    <state id=\"B_send\">\n      <onentry>\n        <assign location=\"currentCommand\" expr=\"commands[commandIndex]\"/>\n        <send event=\"submit.cmd\"><content expr=\"currentCommand\"/></send>\n      </onentry>\n      <transition target=\"W\"/>\n    </state>\n  </state>\n\n  <state id=\"W\">\n    <onentry>\n      <send event=\"trace\"><content expr=\"'Waiting for server reply.'\"/></send>\n    </onentry>\n    <transition event=\"reply.2xx\" target=\"B\">\n      <assign location=\"lastReply\" expr=\"_event.data\"/>\n      <assign location=\"commandIndex\" expr=\"commandIndex + 1\"/>\n    </transition>\n    <transition event=\"reply.3xx\" target=\"P\">\n      <assign location=\"lastReply\" expr=\"_event.data\"/>\n    </transition>\n    <transition event=\"reply.4xx reply.5xx\" target=\"F\">\n      <assign location=\"lastReply\" expr=\"_event.data\"/>\n    </transition>\n  </state>\n\n  <state id=\"P\">\n    <onentry>\n      <assign location=\"currentCommand\" expr=\"'PASS'\"/>\n      <send event=\"submit.cmd\"><content expr=\"'PASS'\"/></send>\n    </onentry>\n    <transition event=\"reply.2xx\" target=\"B\">\n      <assign location=\"lastReply\" expr=\"_event.data\"/>\n      <assign location=\"commandIndex\" expr=\"commandIndex + 1\"/>\n    </transition>\n    <transition event=\"reply.4xx reply.5xx\" target=\"F\">\n      <assign location=\"lastReply\" expr=\"_event.data\"/>\n    </transition>\n  </state>\n\n  <final id=\"S\">\n    <onentry>\n      <send event=\"trace\"><content expr=\"'Success: command sequence completed.'\"/></send>\n    </onentry>\n  </final>\n\n  <final id=\"F\">\n    <onentry>\n      <send event=\"trace\"><content expr=\"'Failure: FTP server returned an error.'\"/></send>\n    </onentry>\n  </final>\n</scxml>\n"

/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ftpClientScxml = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scxml = __webpack_require__(28);
	
	var _scxml2 = _interopRequireDefault(_scxml);
	
	var _schviz = __webpack_require__(13);
	
	var _schviz2 = _interopRequireDefault(_schviz);
	
	var _ftpClientPanel = __webpack_require__(395);
	
	var _ftpClientPanel2 = _interopRequireDefault(_ftpClientPanel);
	
	var _ftpClient = __webpack_require__(894);
	
	var _ftpClient2 = _interopRequireDefault(_ftpClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.ftpClientScxml = _ftpClient2.default;
	
	var QtFtpClientExample = function (_React$Component) {
	  _inherits(QtFtpClientExample, _React$Component);
	
	  function QtFtpClientExample(props) {
	    _classCallCheck(this, QtFtpClientExample);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { log: [], commands: [] };
	    return _this;
	  }
	
	  QtFtpClientExample.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    _scxml2.default.documentStringToModel(null, _ftpClient2.default, function (err, model) {
	      if (err) throw err;
	      model.prepare(function (err, modelFactory) {
	        if (err) throw err;
	        _this2.sc = new _scxml2.default.scion.Statechart(modelFactory, {
	          customSend: _this2.customSend.bind(_this2)
	        });
	
	        var transitionsEnabled = void 0;
	        _this2.sc.on('onBigStepBegin', function () {
	          transitionsEnabled = new Map();
	        });
	        _this2.sc.on('onBigStepEnd', function () {
	          var _sc$getSnapshot = _this2.sc.getSnapshot(),
	              _ = _sc$getSnapshot[0],
	              history = _sc$getSnapshot[1],
	              isInFinalState = _sc$getSnapshot[2],
	              datamodel = _sc$getSnapshot[3];
	
	          _this2.setState({
	            datamodel: datamodel,
	            configuration: _this2.sc.getFullConfiguration(),
	            transitionsEnabled: transitionsEnabled
	          });
	        });
	        _this2.sc.on('onTransition', function (transitionSourceId, targetIds, transitionIndex) {
	          if (transitionsEnabled.has(transitionSourceId)) {
	            transitionsEnabled.get(transitionSourceId).add(transitionIndex);
	          } else {
	            transitionsEnabled.set(transitionSourceId, new Set([transitionIndex]));
	          }
	        });
	        _this2.sc.start();
	      });
	    });
	  };
	
	  QtFtpClientExample.prototype.customSend = function customSend(event) {
	    if (event.name === 'trace') {
	      this.setState(function (_ref) {
	        var log = _ref.log;
	        return { log: log.concat(event.data).slice(-12) };
	      });
	    } else if (event.name === 'submit.cmd') {
	      this.setState(function (_ref2) {
	        var commands = _ref2.commands;
	        return { commands: commands.concat(event.data).slice(-12) };
	      });
	    } else {
	      this.sc.gen(event);
	    }
	  };
	
	  QtFtpClientExample.prototype.send = function send(event) {
	    if (this.sc) this.sc.gen(event);
	  };
	
	  QtFtpClientExample.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'row', style: { minHeight: '560px' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-8', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '560px', width: '100%', position: 'relative', border: '1px solid #eee' } },
	          _react2.default.createElement(_schviz2.default, {
	            scxmlDocumentString: _ftpClient2.default,
	            disableAnimation: true,
	            disableZoom: true,
	            configuration: this.state && this.state.configuration,
	            disableZoomAnimation: true,
	            transitionsEnabled: this.state && this.state.transitionsEnabled,
	            expandAllStatesByDefault: true,
	            layoutOptions: _schviz2.default.layouts.auto,
	            id: 'qt-ftp-client'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-4', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '560px', border: '1px solid #eee' } },
	          _react2.default.createElement(_ftpClientPanel2.default, {
	            configuration: this.state.configuration,
	            datamodel: this.state.datamodel,
	            commands: this.state.commands,
	            log: this.state.log,
	            onEvent: function onEvent(event) {
	              return _this3.send(event);
	            }
	          })
	        )
	      )
	    );
	  };
	
	  return QtFtpClientExample;
	}(_react2.default.Component);
	
	exports.default = QtFtpClientExample;

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _prismjs = __webpack_require__(38);
	
	var _prismjs2 = _interopRequireDefault(_prismjs);
	
	var _reactPrism = __webpack_require__(22);
	
	var _reactPrism2 = _interopRequireDefault(_reactPrism);
	
	var _TutorialPageWrapper = __webpack_require__(18);
	
	var _TutorialPageWrapper2 = _interopRequireDefault(_TutorialPageWrapper);
	
	var _qtFtpClientExample = __webpack_require__(396);
	
	var _qtFtpClientExample2 = _interopRequireDefault(_qtFtpClientExample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var FtpClient = function FtpClient(_ref) {
	  var sectionName = _ref.sectionName,
	      by = _ref.by;
	  return React.createElement(
	    'div',
	    null,
	    React.createElement(
	      'h1',
	      null,
	      sectionName
	    ),
	    React.createElement(
	      'h6',
	      null,
	      by
	    ),
	    React.createElement(
	      'p',
	      null,
	      'This ports the state structure described in Qt\'s SCXML FTP Client example into a browser simulation. The panel stands in for the FTP control channel by sending server reply events and recording commands emitted by the statechart.'
	    ),
	    React.createElement(_qtFtpClientExample2.default, null),
	    React.createElement(
	      'h2',
	      null,
	      'SCXML source'
	    ),
	    React.createElement(
	      _reactPrism2.default,
	      { component: 'pre', className: 'language-xml' },
	      _qtFtpClientExample.ftpClientScxml
	    )
	  );
	};
	
	var WrappedFtpClient = function WrappedFtpClient(_ref2) {
	  var location = _ref2.location;
	  return React.createElement(_TutorialPageWrapper2.default, { Component: FtpClient, pathname: location.pathname });
	};
	
	exports.default = WrappedFtpClient;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tutorials-examples-ftp-client-js-f73854f41476b8ff8b17.js